<template>
    <div>
        <div v-if="configurable.input_type === 'period'">
            <div class="input-group w-xl-50" :class="{'cursor-not-allowed': !configurable.editable}">
                <input class="form-control text-center"
                       :class="{
                    'cursor-not-allowed': !configurable.editable,
                    'border-danger': hasErrors
                }"
                       type="number"
                       :name="`fields[${configurable.field}][value]`"
                       v-model="config.value"
                       :disabled="!configurable.editable">

                <select class="form-control"
                        :class="{
                    'cursor-not-allowed': !configurable.editable,
                    'border-danger': hasErrors
                }"
                        :name="`fields[${configurable.field}][unit]`"
                        :disabled="!configurable.editable"
                        v-model="config.unit">
                    <option v-for="(periodLabel, period) in configurable.attachments.unit" :key="period"
                            :value="period"
                            :selected="config.unit === period"
                            v-text="periodLabel"/>
                </select>
            </div>
        </div>
        <toggle v-else-if="configurable.input_type === 'bool'"
                class="h-3em"
                :name="`fields[${configurable.field}][value]`"
                :active="toggleValue(configurable)"
                @change="active => config.value = active"
        />
        <div v-else-if="configurable.input_type === 'array'" class="d-flex flex-column gap-3">
            <div v-for="(child, index) in config.value" class="d-flex flex-row">
                <input class="form-control w-100"
                       :type="configurable.input_type"
                       :name="`fields[${configurable.field}][value][${index}]`"
                       :disabled="!configurable.editable"
                       :placeholder="configurable.label"
                       v-model="config.value[index]"
                >
                <div class="position-absolute pt-2 pr-5" style="right: 0;">
                    <button class="btn btn-xs btn-light-danger mr-1" type="button" @click="removeArrayItem(child)">
                        <i class="fas fa-trash ml-1" style="margin: 1px 0;"/>
                    </button>
                </div>
            </div>
            <button class="btn btn-sm btn-secondary" type="button" @click="addArrayEntry">
                <i class="fas fa-plus-square"/>
                {{ __('actions.add_another_entry') }}
            </button>
        </div>
        <div v-else>
            <div class="form-control d-flex flex-row justify-content-start overflow-hidden"
                 :class="{'border-danger': hasErrors}" @focus="redirectFocus"
                 @click="redirectFocus">
                <span v-if="configurable.input_prefix"
                      class="text-muted pointer-events-none text-nowrap"
                      v-text="configurable.input_prefix"/>
                <input ref="input"
                       class="border-0 p-0"
                       :class="{'w-100': (!configurable.input_prefix && !configurable.input_suffix)}"
                       style="color: inherit; outline: none;"
                       :type="configurable.input_type"
                       :name="`fields[${configurable.field}][value]`"
                       :disabled="!configurable.editable"
                       :placeholder="configurable.label"
                       :maxlength="getMaxLength(configurable)"
                       @keyup="resizeInput"
                       v-model="config.value"
                >
                <span v-if="configurable.input_suffix"
                      class="text-muted pointer-events-none text-nowrap"
                      v-text="configurable.input_suffix"/>
            </div>
        </div>

        <div v-for="error in errors" class="form-text text-danger" v-text="error"/>

        <input type="hidden"
               :name="`fields[${configurable.field}][field]`"
               :value="configurable.field"
               :disabled="!configurable.editable">

        <input type="hidden"
               :name="`fields[${configurable.field}][type]`"
               :value="configurable.input_type"
               :disabled="!configurable.editable">
    </div>
</template>

<script>
import Toggle from '@components/Toggle'

export default {
    components: {
        Toggle,
    },

    props: {
        value: Object,
        configurable: Object,
        errors: {
            types: [Object, Array],
            default() {
                return {}
            },
        },
    },

    data() {
        return {
            config: {},
        }
    },

    beforeMount() {
        this.config = this.value
    },

    mounted() {
        this.$nextTick(() => {
            this.resizeInput()
        })
    },

    methods: {
        addArrayEntry() {
            this.config.value.push('')
        },

        removeArrayItem(child) {
            let newArray = []
            for (let entry of this.config.value) {
                if (entry !== child) {
                    newArray.push(entry)
                }
            }
            this.config.value = newArray
        },

        toggleValue(configurable) {
            if (configurable.hasOwnProperty('value') && configurable.value !== null) {
                return configurable.value
            }

            return configurable.default
        },

        redirectFocus() {
            this.$refs.input.focus()
        },

        resizeInput() {
            if (this.$refs.input) {
                let length = this.$refs.input.value.length
                if (length === 0) {
                    length = 1
                }
                this.$refs.input.style.width = length + 'ch'
            }
        },

        getMaxLength(configurable) {
            let validations = configurable.validation
            for (let validation of validations) {
                if (validation.startsWith('max')) {
                    return parseInt(validation.split(':')[1])
                }
            }

            return null
        },
    },

    computed: {
        hasErrors() {
            return this.errors.length > 0
        },
    },
}
</script>
